import { useTranslation } from "react-i18next"
import moment from "moment"

export type MonthItem = {
  label: string
  value: string
}

export const useGenerateLast12Months = (): MonthItem[] => {
  const { t } = useTranslation()
  let months: MonthItem[] = [{ label: t("all_months"), value: "" }]
  const currentMonth = moment()

  for (let i = 0; i < 12; i++) {
    const monthLabel = `${t(
      `month_${currentMonth.clone().subtract(i, "months").locale("en").format("MMMM")}`,
    )} ${currentMonth.clone().subtract(i, "months").format("YYYY")}`
    months.push({ label: monthLabel, value: monthLabel })
  }

  return months
}

export const useGenerateNext12Months = (): MonthItem[] => { 
    const { t } = useTranslation();
    let months: MonthItem[] = [{ label: t("all_months"), value: "" }];
    const currentMonth = moment();

  for (let i = 0; i < 12; i++) {
    const monthLabel = `${t(
      `month_${currentMonth.clone().add(i, "months").locale("en").format("MMMM")}`,
    )} ${currentMonth.clone().add(i, "months").format("YYYY")}`
    months.push({ label: monthLabel, value: monthLabel })
  }

    return months;
}


